import { ExamCenterCreationButton } from '@exam-center/exam-center-creation';
import { BusinessOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function ExamCenterListNoRowsOverlay() {
  //TODO: apply permission after add exam-center api is ready

  return (
    <NoRowsOverlay
      icon={BusinessOutlinedIcon}
      title='ยังไม่มีศูนย์ทดสอบ'
      description='คลิกปุ่มด้านล่างเพื่อเพิ่มศูนย์ทดสอบ'
      action={<ExamCenterCreationButton variant='outlined' />}
    />
  );
}
